export enum COLOR_SCHEME {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
  }